import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Lock, ChevronLeft } from "lucide-react";
import { toast } from "sonner";
import { formatError } from "@/lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, Dr. Ashish");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatError(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-clinic-bg flex flex-col items-center justify-center px-6">
      <Link to="/" className="absolute top-6 left-6 text-sm text-clinic-muted hover:text-clinic-pine inline-flex items-center gap-1" data-testid="admin-back">
        <ChevronLeft size={16} /> Back to site
      </Link>
      <div className="w-full max-w-md card-elevated p-8 md:p-10">
        <div className="w-12 h-12 rounded-full bg-clinic-pine text-clinic-bg grid place-items-center">
          <Lock size={20} />
        </div>
        <h1 className="font-heading text-3xl mt-6 tracking-tight">Clinic Admin</h1>
        <p className="text-sm text-clinic-muted mt-2">Sign in to manage appointments and contact messages.</p>
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
          <input
            data-testid="admin-email-input"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            type="email"
            required
            placeholder="Email"
            className="w-full px-4 py-3 rounded-xl border border-clinic-line bg-white focus:outline-none focus:border-clinic-pine"
          />
          <input
            data-testid="admin-password-input"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            type="password"
            required
            placeholder="Password"
            className="w-full px-4 py-3 rounded-xl border border-clinic-line bg-white focus:outline-none focus:border-clinic-pine"
          />
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
